import { render } from "./ConstantCompositionExpansion.vue?vue&type=template&id=c5fff3da"
import script from "./ConstantCompositionExpansion.vue?vue&type=script&lang=js"
export * from "./ConstantCompositionExpansion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__